<template>
  <div class="content "
       :class="{'loading-overlay loading-overlay-progress': donationsState !== 'ready'}">

    <reports-menu
        :start-date="startDate"
        :end-date="endDate"
        :first-donation-date="firstDonationDate"
        v-on:update-date="updateDate"
        v-on:download="download"
    ></reports-menu>

    <div class="flex flex-wrap overflow-hidden px-8 md:px-4 pt-4 d-reports tab-donations">
      <div class="w-4/5 xl:w-4/6 md:w-full pr-5 md:pr-0">
        <div class="d-block shadow-md donations-summary">
          <h3 class="title">
            <div class="row">
              <div class="col-sm-6">Analytics</div>
              <div class="col-sm-6 text-right "><span>{{selected(startDate, endDate) | intervalLabel}}</span></div>
            </div>
          </h3>

          <div class="d-block-chart" style="margin-bottom: 0">
            <div id="graph" class="graph"></div>
          </div>
        </div>
      </div>
      <div class="w-1/5 xl:w-2/6 md:w-full">
        <div v-if="donationsState === 'ready'"
             class="d-block d-block-overview summary shadow-md rounded-md bg-white px-6 py-4">
          <h2>Summary</h2>
          <div class="welcome">{{selected(startDate, endDate) | intervalLabel}}</div>
          <div class="total">
            <i class="just-wrap text-3xl">${{(summary.custom + summary.rounds + summary.monthly) / 100 | formatMoney}}</i>
            <span v-if="diffPercent"
                  class="percent-diff"
                  :class="{'negative': diffPercent<0}"
            >{{diffPercent > 0 ? '+' : ''}}{{diffPercent}}%</span>
          </div>
          <div class="welcome">Donation Totals
            <router-link to="/reports/donations" class="text-blue-400">View Report</router-link>
          </div>
          <table class="table">
            <tbody>
            <tr>
              <td>One-Time</td>
              <td class="value txt-orange">${{summary.custom / 100 | formatMoney}}</td>
            </tr>
            <tr>
              <td>Monthly</td>
              <td class="value txt-green">${{summary.monthly / 100 | formatMoney}}</td>
            </tr>
            <tr>
              <td>Round-Ups</td>
              <td class="value txt-blue">${{summary.rounds / 100 | formatMoney}}</td>
            </tr>
            <tr>
              <td>Total Donations</td>
              <td class="value">${{(summary.custom + summary.rounds + summary.monthly) / 100 | formatMoney}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {formatMoney, saveCSV} from '../../utils/utils';
  import ReportsMenu from './menu.vue';
  import reportsMixin from './reports-mixin';
  import reportsMenuMixin from './reports-menu-mixin';
  import {mapState} from "vuex";

  const moment = require('moment');

  export default {
    name: 'Reports',
    mixins: [reportsMixin, reportsMenuMixin],
    mounted() {
      if (this.donationsState === 'ready' && this.donorsState === 'ready') {
        this.updateAnalytics();
      }
    },
    components: {
      ReportsMenu,
    },
    metaInfo: {
      title: 'Reports - Analytics',
    },
    methods: {
      download(type) {

        const analyticsData = JSON.parse(JSON.stringify(this.exportData));
        const title = `Donation Reports ${this.period.start.format('MMM D YYYY')} - ${this.period.end.format(
          'MMM D YYYY')}`;

        if (type === 'pdf') {
// eslint-disable-next-line
          let doc = new jsPDF('landscape');
          doc.text(title, 15, 20);
          doc.autoTable(
            ['Date', 'Donors', 'Sign-Ups', 'Donations', 'Round-Ups', 'Monthly', 'One-time', 'Total Donations'],
            analyticsData, {
              margin: {top: 25},
            });
          doc.save(`${title}.pdf`);
        }
        else{
          saveCSV(
            [
              [title],
              ['Date', 'Donors', 'Sign-Ups', 'Donations', 'Round-Ups', 'Monthly', 'One-time', 'Total Donations'],
              ...analyticsData
            ],
            {
              filename: `${title}.csv`,
              addHeader: false
            }
          );
        }
      },
      getGroupKey: function(date, interval) {
        switch (interval) {
          case 'month':
            return date.format('YYYYMM');

          default:
            return date.format('YYYYMMDD');

        }
      },
      updateAnalytics() {

        let dates = new Map();

        const selectedInterval = this.selected(this.startDate, this.endDate);

        const groupInterval = ['This Year', 'Last Year'].indexOf(selectedInterval.title) !== -1 ? 'month' : 'day';

        for (let i = this.period.end.clone(); i.isAfter(this.period.start); i.subtract(1, 'day')) {
          dates.set(this.getGroupKey(i, groupInterval), {
            title: groupInterval === 'day' ? i.format('ddd M/D') : i.format('MMMM'),
            title2: i.format('MMM D, YY'),
            title3: groupInterval === 'day' ? i.format('MMMM D, YYYY') : i.format('MMMM'),
            titleDay: groupInterval === 'day' ? i.format('dddd') : i.format('MMMM'),
            custom: 0,
            monthly: 0,
            rounds: 0,
            signup: 0,
            donors: 0,
            donations: 0,
          });
        }

        for (let donation of this.donationsData) {
          const dt = moment(donation.created_at, 'YYYY/MM/DD HH:mm:ss');

          let tmp = dates.get(this.getGroupKey(dt, groupInterval));
          tmp.donations++;

          switch (donation.type) {
            case 'custom':
              tmp.custom += donation.amount * 1;
              break;
            case 'roundup':
              tmp.rounds += donation.amount * 1;
              break;
            case 'recurring':
              tmp.monthly += donation.amount * 1;
              break;
            default:
          }

          dates.set(this.getGroupKey(dt, groupInterval), tmp);
        }

        for (let donor of this.donors) {
          let mdt = this.getGroupKey(moment(donor.created_at), groupInterval);

          if (dates.has(mdt)) {
            let tt = dates.get(mdt);
            tt.signup++;
            dates.set(mdt, tt);
          }
        }

        let tmpTotal = this.donors.length;

        this.exportData = [];

        dates.forEach((value) => {
          this.exportData.push([
            `${value.title3}`,
            tmpTotal,
            value.signup,
            value.donations,
            '$' + formatMoney(value.rounds / 100, 2, 18),
            '$' + formatMoney(value.monthly / 100, 2, 18),
            '$' + formatMoney(value.custom / 100, 2, 18),
            '$' + formatMoney((value.rounds + value.custom + value.monthly) / 100, 2, 18),
          ]);

          tmpTotal -= value.signup;
        });

        let arr1 = [];
        let arr2 = [];
        let arr3 = [];
        let arr4 = [];

        dates.forEach(function(value) {
          arr1.push(value.title);
          arr2.push(value.custom / 100);
          arr3.push(value.rounds / 100);
          arr4.push(value.monthly / 100);
        });

        this.drawChart(arr1.reverse(), arr2.reverse(), arr3.reverse(), arr4.reverse());

        // if (this.donations.length > 0) {
        //   const firstDonationDate = moment(this.donations[this.donations.length - 1].created_at)
        //
        //   if (firstDonationDate) {
        //     this.firstDonationDate = firstDonationDate.format('MM/DD/YYYY');
        //   }
        // }
      },
      updatePage() {
        if (this.donationsState === 'ready' && this.donorsState === 'ready') {
          this.updateAnalytics();
        }
      }
    },
    computed: {
      ...mapState({
        donations: state => state.donations.donations,
        donationsState: state => state.donations.donationsState,
        donors: state => state.donors.donors,
        donorsState: state => state.donors.donorsState,
        activeCharityId: state => state.auth.activeCharityId,
      }),
      newDonors() {
        if (!this.donorsState !== 'ready') {
          return [];
        }
        return this.donors.filter(donor => {
          let mdt = moment(donor.created_at);
          return (mdt > this.period.start && mdt < this.period.end);
        });
      },
    },
    beforeRouteUpdate (to, from, next) {
      this.$nextTick(() => {
        const startDate = ('start-date' in this.$route.query) ? moment(this.$route.query['start-date'], 'MM-DD-YYYY').
          format('MM/DD/YYYY') : moment().subtract(29, 'days').format('MM/DD/YYYY');
          const endDate = ('end-date' in this.$route.query) ? moment(this.$route.query['end-date'], 'MM-DD-YYYY').
          format('MM/DD/YYYY') : moment().format('MM/DD/YYYY');

        this.updateDate(startDate, endDate);
      });
      next();
    },
    watch: {
      'donations'() {
        if (this.donationsState === 'ready' && this.donorsState === 'ready') {
          this.updateAnalytics();
        }
      },
      'donors'() {
        if (this.donationsState === 'ready' && this.donorsState === 'ready') {
          this.updateAnalytics();
        }
      },
      'activeCharityId'() {
        if (this.donationsState === 'ready' && this.donorsState === 'ready') {
          this.updateAnalytics();
        }
      },
    },
    data() {
      return {
        exportData: [],
      };
    },
  };
</script>
